import { useEffect, useState } from 'react';
import SlotItem from './SlotItem.js';


export default function SectionGender({ gender, setGender }) {
    return (
        <div data-slot='gender'>
            <h2>Gender</h2>
            <ul>
                <SlotItem gender='female' active={gender === 'female'} onClick={() => { setGender('female'); }} image='/img/icon-gender-b.svg' />
                <SlotItem gender='male' active={gender === 'male'} onClick={() => { setGender('male'); }} image='/img/icon-gender-a.svg' />
            </ul>
        </div>
    )
}
